import apiServiceCall from "../services/ApiServiceCall";

export const getContactData = () => {
  return apiServiceCall().get('/vui/frontend/branches').then(({ data }) => data);
}

// Alias para compatibilidad con código existente
export const getContactDataFromWordpress = getContactData;

export const sendMessage = (requestData) => {
  return apiServiceCall().post('/send/claim', requestData).then(({ data }) => data);
}
